( function() {
"use strict";
	var $ = require('jquery');
 	var Masonry = require('masonry-layout');

	// var msnry = new Masonry( '.footer-menu', {
	// 	columnWidth: '.footer-menu__item--parent',
	// 	percentPosition: true,
	// 	itemSelector: '.footer-menu__item--parent'
	// });


})();
